module.exports = __webpack_public_path__ + "static/macbookContainer-b7b8c52f1675ce3306fe2dbaf3210952.png";